import React from 'react';
import { Row, Col } from 'react-bootstrap';
import UsersActivity from "../../RecentActivity/UserActivity";
import RecentActivity from "../../RecentActivity/recentactivity";

/**
 * "User Activity Section": the user activity log and the data-owner activity log side by side.
 */
const UserActivitySection = ({ usersActivities, todaysActivities }) => (
  <>
    <div className="section-header mt-5 mb-3" style={{ borderBottom: '1px solid rgba(99,102,241,0.08)', paddingBottom: '12px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1E293B', fontFamily: 'Inter, sans-serif', margin: 0 }}>
        User Activity Section
      </h2>
    </div>

    <Row className="mb-5">
      <Col md={6}>
        <div className="d-flex flex-row flex-space-between">
          <div className="dashboard-component" style={{ width: "100%" }}>
            <UsersActivity
              usersActivity={usersActivities}
              heading="User's activity log"
            />
          </div>
        </div>
      </Col>
      <Col md={6}>
        <div className="d-flex flex-row flex-space-between">
          <div className="dashboard-component" style={{ width: "100%" }}>
            <RecentActivity
              todaysActivities={todaysActivities}
              heading="Data owner's activity log"
            />
          </div>
        </div>
      </Col>
    </Row>
  </>
);

export default UserActivitySection;
